import { useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const categoryImages: Record<string, string> = {
  magic: 'https://readdy.ai/api/search-image?query=A%20magical%20library%20with%20floating%20books%20and%20glowing%20spell%20circles%2C%20warm%20golden%20ambient%20light%2C%20mystical%20fantasy%20atmosphere%2C%20ancient%20wooden%20shelves%2C%20detailed%20anime%20art%20style&width=400&height=280&seq=cat-magic&orientation=landscape',
  fantasy: 'https://readdy.ai/api/search-image?query=A%20breathtaking%20fantasy%20kingdom%20with%20castles%20on%20floating%20islands%2C%20dragons%20flying%20in%20golden%20skies%2C%20epic%20landscape%2C%20warm%20sunset%20lighting%2C%20detailed%20anime%20fantasy%20art&width=400&height=280&seq=cat-fantasy&orientation=landscape',
  superpower: 'https://readdy.ai/api/search-image?query=A%20futuristic%20city%20at%20night%20with%20energy%20beams%20and%20force%20fields%2C%20superpowered%20individuals%20in%20dynamic%20poses%2C%20neon%20lights%2C%20dramatic%20anime%20action%20style&width=400&height=280&seq=cat-superpower&orientation=landscape',
  adventure: 'https://readdy.ai/api/search-image?query=An%20ancient%20ruin%20in%20a%20dense%20jungle%20with%20treasure%20chests%20and%20mysterious%20carvings%2C%20sunbeams%20piercing%20through%20canopy%2C%20adventure%20anime%20art%2C%20warm%20atmospheric%20lighting&width=400&height=280&seq=cat-adventure&orientation=landscape',
  xuanhuan: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20mountain%20temples%20floating%20in%20clouds%2C%20cultivators%20riding%20swords%2C%20golden%20spiritual%20energy%20flowing%2C%20traditional%20ink%20painting%20style%20with%20anime%20aesthetic&width=400&height=280&seq=cat-xuanhuan&orientation=landscape',
  urban: 'https://readdy.ai/api/search-image?query=A%20modern%20city%20street%20at%20twilight%20with%20hidden%20supernatural%20elements%2C%20spirit%20creatures%20disguised%20as%20humans%2C%20warm%20street%20lamps%2C%20urban%20fantasy%20anime%20style&width=400&height=280&seq=cat-urban&orientation=landscape',
};

export default function CategorySection() {
  const navigate = useNavigate();

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            探索漫画分类
          </h2>
          <p className="text-foreground-500 max-w-2xl mx-auto text-sm md:text-base">
            从魔法到异能，从奇幻到玄幻，海量分类等你来发掘。找到属于你的魔法世界，开启非麻瓜专属的漫画之旅。
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={`/category/${cat.slug}`}
              onClick={(e) => { e.preventDefault(); navigate(`/category/${cat.slug}`); }}
              className="group relative rounded-xl overflow-hidden cursor-pointer h-44 md:h-52"
            >
              <img
                src={categoryImages[cat.id] || categoryImages.magic}
                alt={cat.name}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute inset-0 flex flex-col items-center justify-end pb-4 px-3">
                <div className="w-10 h-10 flex items-center justify-center bg-background-50/20 backdrop-blur-sm rounded-full mb-2">
                  <i className={`${cat.icon} text-background-50 text-lg`}></i>
                </div>
                <span className="text-background-50 font-heading font-semibold text-sm whitespace-nowrap">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}